import { Base } from "@app/controllers/base";

// Connects to data-controller="components--modal"
export default class extends Base {
  static targets = ["modal", "file", "code", "download", "imageViewer", "pdfViewer", "filename"]

  open(event) {
    const src = event.currentTarget.dataset.modalSrcParam
    const code = event.currentTarget.dataset.modalCodeParam
    const isPdf = event.currentTarget.dataset.modalIsPdfParam === "true"
    const filename = event.currentTarget.dataset.modalFilenameParam

    this.codeTarget.textContent = code
    this.downloadTarget.href = src

    if (isPdf && this.hasPdfViewerTarget) {
      this.fileTarget.classList.add("hidden")
      this.pdfViewerTarget.classList.remove("hidden")
      this.pdfViewerTarget.src = src
      if (this.hasFilenameTarget) this.filenameTarget.textContent = filename
    } else {
      if (this.hasPdfViewerTarget) this.pdfViewerTarget.classList.add("hidden")
      this.fileTarget.classList.remove("hidden")
      this.fileTarget.src = src
    }

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")

    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.remove("flex")
    this.modalTarget.classList.add("hidden")

    document.body.classList.remove("overflow-hidden")
  }
}
